import { Swiper } from './swiper-YSyQLWy6.js';
import { N as Navigation } from './navigation-yBYgHuIg.js';
import { P as Pagination } from './pagination-aNzRn7gP.js';
import { A as A11y } from './a11y-crvyJz6s.js';
import './utils-DfPPEfgu.js';
import './create-element-if-not-defined-BQEJuiIf.js';
import './classes-to-selector-BKH7ThcP.js';

class SubcategorySlider extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    const paginationEl = this.querySelector('.swiper-pagination');
    const prevEl = this.querySelector('[data-swiper-prev]');
    const nextEl = this.querySelector('[data-swiper-next]');

    const modules = [A11y];
    /** @type {import('swiper').SwiperOptions} */
    const swiperOptions = {
      modules,
      slidesPerView: 'auto',
      spaceBetween: 8,
    };

    if (paginationEl) {
      modules.push(Pagination);
      swiperOptions.pagination = {
        el: paginationEl,
        type: 'progressbar',
      };
    }

    if (prevEl && nextEl) {
      modules.push(Navigation);
      swiperOptions.navigation = {
        prevEl,
        nextEl,
        addIcons: false,
      };
    }

    new Swiper(swiperEl, swiperOptions);
  }
}

if (!customElements.get('subcategory-slider'))
  customElements.define('subcategory-slider', SubcategorySlider);
